import ResetPasswordForm from "@/features/auth/reset-password/components/ResetPasswordForm";

export default function ResetPassword() {
  return <ResetPasswordForm />;
}
